(() => {
  function init(scope = document) {
    scope.querySelectorAll('.soyul-pdp').forEach(root => {
      if (root.dataset.galleryReady) return;
      root.dataset.galleryReady = 'true';
      const gallery = root.querySelector('[data-soyul-gallery]');
      const slides = [...root.querySelectorAll('[data-soyul-media]')];
      const thumbs = [...root.querySelectorAll('[data-soyul-photo]')];
      const counter = root.querySelector('[data-soyul-current]');
      const prev = root.querySelector('[data-soyul-prev]');
      const next = root.querySelector('[data-soyul-next]');
      let index = 0;
      let measuredWidth = 0;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const narrow = window.matchMedia('(max-width: 989px)');
      function fit(i = index) {
        if (!gallery) return;
        if (!narrow.matches) {
          gallery.style.removeProperty('--soyul-gallery-height');
          return;
        }
        const slide = slides[i] || slides[0];
        const image = slide?.querySelector('img');
        const declared = Number.parseFloat(slide?.style.getPropertyValue('--soyul-media-ratio'));
        const natural = image?.naturalWidth && image?.naturalHeight ? image.naturalWidth / image.naturalHeight : 0;
        const ratio = declared || natural || .8;
        const width = gallery.clientWidth || root.clientWidth;
        if (!width) return;
        // Keep the frame at the media's real ratio. Clamping its height used to
        // make portrait product shots look cropped on smaller mobile screens.
        const height = width / ratio;
        gallery.style.setProperty('--soyul-gallery-height', `${Math.round(height)}px`);
      }
      function go(i) { gallery.scrollTo({left: Math.max(0, Math.min(slides.length - 1, i)) * gallery.clientWidth, behavior: reduced.matches ? 'instant' : 'smooth'}); }
      function reflect(i) {
        if (i === index && measuredWidth) return;
        index = i;
        fit(i);
        if (counter) counter.textContent = String(i + 1);
        thumbs.forEach((button, n) => button.setAttribute('aria-pressed', String(n === i)));
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides.length - 1;
      }
      if (gallery && slides.length > 1) {
        root.querySelectorAll('[data-soyul-gallery-nav]').forEach(nav => nav.hidden = false);
        prev?.addEventListener('click', () => go(index - 1));
        next?.addEventListener('click', () => go(index + 1));
        thumbs.forEach((button, i) => button.addEventListener('click', () => go(i)));
        gallery.addEventListener('keydown', event => { if (event.target === gallery && ['ArrowLeft','ArrowRight'].includes(event.key)) { event.preventDefault(); go(index + (event.key === 'ArrowLeft' ? -1 : 1)); } });
        let frame;
        gallery.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(() => reflect(Math.min(slides.length - 1, Math.max(0,Math.round(gallery.scrollLeft / gallery.clientWidth))))); }, {passive:true});
        reflect(0);
      }
      else fit(0);
      slides.forEach((slide, i) => {
        const image = slide.querySelector('img');
        if (image && !image.complete) image.addEventListener('load', () => { if (i === index) fit(i); }, { once: true });
      });
      const stage = root.querySelector('.soyul-pdp__stage');
      if ('ResizeObserver' in window && stage) {
        new ResizeObserver(entries => {
          const width = Math.round(entries[0]?.contentRect.width || 0);
          if (width && width !== measuredWidth) { measuredWidth = width; fit(index); }
        }).observe(stage);
      } else window.addEventListener('resize', () => fit(index), { passive: true });
      const selection = root.querySelector('[data-soyul-selection]');
      const select = root.querySelector('[data-soyul-variant-id]');
      const sync = () => { if (selection && select) selection.textContent = select.selectedOptions[0]?.textContent.split(' — ')[0] || 'Indisponible'; };
      select?.addEventListener('change', sync);
    });
  }
  document.addEventListener('DOMContentLoaded', () => init());
  if (document.readyState !== 'loading') init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
